import { useCallback } from 'react';

import { useCreateOtpSessionByPlatformMutation } from '@ocx/graphql';

import { RequestOtpParams } from './signup.types';
import { getOTPPlatform } from './signup.utils';

export const useRequestOTP = () => {
  const [_requestOTP, { loading }] = useCreateOtpSessionByPlatformMutation({ fetchPolicy: 'network-only' });

  const requestOTP = useCallback(
    async (values: RequestOtpParams): Promise<{ session: string } | null> => {
      const res = await _requestOTP({
        variables: {
          input: {
            phoneNumber: values.phoneNumber,
            otpChannel: values.otpChannel,
            otpPlatform: getOTPPlatform(),
            referralCode: values.referralCode || undefined,
          },
        },
      });

      if (res.errors?.length) {
        throw res.errors[0];
      }

      if (!res?.data?.createOTPSessionByPlatform.session) {
        return null;
      }

      return { session: res.data.createOTPSessionByPlatform.session };
    },
    [_requestOTP],
  );

  return { requestOTP, isLoading: loading };
};
